import { MarkdownEditorField } from '@/components/markdown/markdown-editor-field'
import {
  Card,
  CardContent,
} from '@/components/ui/card'
import { useAuth } from '@/hooks/use-auth'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import PersonaSelector from './-components/persona-selector'
import { CardHeaderWithBadge } from './-components/card-header-with-badge'
import { useCompanyFieldForm } from './-components/use-company-field-form'

const parentRoute = getRouteApi('/_authed/_user/organization')

export const Route = createFileRoute(
  '/_authed/_user/organization/customers',
)({
  component: CustomersSection,
  beforeLoad: () => ({
    getTitle: () => 'Customers',
    getDescription: () => 'Define your ideal customer profile and target personas',
  }),
})

function CustomersSection() {
  const { canEditOrgSettings: canEdit, canEditPersonas } = useAuth()
  const { initialData, hasCompanyInfo } = parentRoute.useLoaderData()

  const { form, NavBlocker } = useCompanyFieldForm({
    fieldName: 'qualificationLogic',
    initialData,
  })

  return (
    <>
      <Card data-tour="org-customers-card" className={canEdit ? '' : 'opacity-75'}>
        <CardHeaderWithBadge
          title="Ideal Customer Profile"
          description="Describe the characteristics of your ideal customers and what makes them a good fit."
          form={form}
          fieldName="qualificationLogic"
          hasCompanyInfo={hasCompanyInfo}
        />
        <CardContent>
          <MarkdownEditorField
            form={form}
            name="qualificationLogic"
            displayModeByDefault
            placeholder="Describe your ideal customer profile and characteristics..."
            disabled={!canEdit}
            showSaveButton={canEdit}
            onSave={() => form.handleSubmit()}
          />
        </CardContent>
      </Card>

      <Card className={canEditPersonas ? '' : 'opacity-75'}>
        <CardHeaderWithBadge
          title="Target Personas"
          description="Define specific types of people you want to reach at your tracked companies. Think of job titles, roles, or departments like &quot;Manufacturing Engineer&quot;, &quot;VP of Operations&quot;, or &quot;Procurement Manager&quot;."
          hasCompanyInfo={hasCompanyInfo}
        />
        <CardContent className="space-y-4">
          <PersonaSelector readOnly={!canEditPersonas} />
        </CardContent>
      </Card>
      <NavBlocker />
    </>
  )
}
